import { getTxtFile } from '@/services/conversations-service/conversations-service';
import { downloadCSVFile } from '@/utils/helpers';
import { useState } from 'react';

export const useGetTxtFile = (id: number) => {
  const [isPending, setIsPending] = useState(false);

  const downloadTXT = async () => {
    setIsPending(true);
    const data = await getTxtFile(id);
    if (typeof data === 'string') {
      downloadCSVFile(data);
      setIsPending(false);
      return data;
    }
    setIsPending(false);
  };

  return { downloadTXT, isPending };
};
